import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import React from 'react'
import styled from 'styled-components'
import { KVPolygon } from 'types'

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 100;
`

const DropdownTrigger = styled.div`
  cursor: pointer;
  width: 100%;
  height: 20px;
  border: 0.5px solid gray;
  position: relative;
  box-sizing: content-box;
  padding: 4px;

  &:hover {
    background-color: rgb(255, 255, 255, 0.2);
  }
`

const DropdownMenu = styled.div`
  position: absolute;
  top: 28px;
  left: -0.5px;
  background-color: rgb(17, 17, 17);
  width: 100%;
  border: 0.5px gray solid;
  box-sizing: content-box;
`

const DropdownOption = styled.div<{ $isSelected: boolean }>`
  width: 100%;
  padding: 4px;

  background-color: ${({ $isSelected }) =>
    $isSelected ? 'rgb(255, 255, 255, 0.4)' : ''};

  &:hover {
    background-color: ${({ $isSelected }) =>
      $isSelected ? 'rgb(255, 255, 255, 0.6)' : 'rgb(255, 255, 255, 0.2)'};
  }
`

export const StatusDropdown: React.FC<{
  selectedPolygon: KVPolygon
}> = ({ selectedPolygon }) => {
  const { updatePolygon } = useKestrelViewerContext()

  const polygonStatus = ['Not Started', 'In Progress', 'Completed', 'Flagged']

  const [isOpen, setIsOpen] = React.useState(false)

  const setStatus = (s: string) => {
    const interiorVisible = s !== 'In Progress'
    updatePolygon(
      selectedPolygon,
      ['polygonStatus', 'polygonInteriorVisible'],
      (a) => {
        a.status = s
        a.interiorVisible = interiorVisible
        return a
      },
      [s, interiorVisible]
    )
  }

  return (
    <StatusContainer>
      <div>Status:</div>
      <DropdownTrigger onClick={() => setIsOpen(!isOpen)}>
        {selectedPolygon.status}
        {isOpen && (
          <DropdownMenu>
            {polygonStatus.map((t) => (
              <DropdownOption
                key={t}
                $isSelected={selectedPolygon.status === t}
                onClick={() => {
                  setStatus(t)
                  setIsOpen(false)
                }}>
                {t}
              </DropdownOption>
            ))}
          </DropdownMenu>
        )}
      </DropdownTrigger>
    </StatusContainer>
  )
}
